import { render, staticRenderFns } from "./FoodCard.vue?vue&type=template&id=5c1674ba&scoped=true&"
import script from "./FoodCard.vue?vue&type=script&lang=js&"
export * from "./FoodCard.vue?vue&type=script&lang=js&"
import style0 from "./FoodCard.vue?vue&type=style&index=0&id=5c1674ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1674ba",
  null
  
)

export default component.exports